import {createSelector} from "reselect";
import {isConnectedToLocalMQTT} from "./mqttSelecor";

const _isOnline = state => state.online.status;

export const isOnline = createSelector(_isOnline, isConnectedToLocalMQTT, (status, mqttLocal) => {
    if (mqttLocal) return false;
    return status;
})
